import { PopoverTrigger as ChakraPopoverTrigger } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import React from 'react';

export interface PopoverTriggerProps {
  children: ReactNode;
}

export const PopoverTrigger = (props: PopoverTriggerProps) => {
  return <ChakraPopoverTrigger {...props} />;
};
